import { ui } from "@/components/ui";
import NoDiarySelected from "@/features/patients/features/interface/components/NoDiarySelected";
import { cn } from "@/lib/utils";
import { isSmall } from "@/services/isSmall";
import { Outlet, useParams } from "@tanstack/react-router";
import { Suspense } from "react";
import type { PatientsSearchT } from "../../../routes/_app/patients";
import PatientsTable from "../features/overview/table/components/PatientsTable";

interface Props {
	settings: PatientsSearchT;
}

import TableSkeleton from "./TableSkeleton";

const PatientsPage = ({ settings }: Props) => {
	const { diaryId } = useParams({ strict: false }) as { diaryId: string };

	return (
		<div className="px-2 w-full">
			{isSmall() ? (
				diaryId ? (
					<Outlet />
				) : (
					<Suspense fallback={<TableSkeleton />}>
						<PatientsTable settings={settings} />
					</Suspense>
				)
			) : (
				<ui.ResizablePanelGroup
					direction="horizontal"
					className="md:min-h-[200px] md:max-h-[98vh] transition-transform duration-1000 ease-in-out"
				>
					<ui.ResizablePanel
						className={cn(
							"md:pr-2",
							diaryId ? "hidden md:flex" : "flex",
							"overflow-scroll",
						)}
						defaultSize={60}
					>
						<Suspense fallback={<TableSkeleton />}>
							<PatientsTable settings={settings} />
						</Suspense>
					</ui.ResizablePanel>
					<ui.ResizableHandle withHandle className={cn("bg-slate-300")} />
					<ui.ResizablePanel className="p-2" defaultSize={40}>
						{diaryId ? <Outlet /> : <NoDiarySelected diaryId={diaryId} />}
					</ui.ResizablePanel>
				</ui.ResizablePanelGroup>
			)}
		</div>
	);
};

export default PatientsPage;
